import request from '@/utils/request'

// 工业列表页面--------------------------------------------

/**
 * 获取工业列表和服务商的共用接口
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=371
 * corp_type_key 工业默认值是 1 服务商是 2
 */
export function getIndustryList(params) {
  return request({
    url: '/account/account_list',
    method: 'get',
    params: params
  })
}

/**
 * 增加工业 获取下拉选择的接口
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=504
 * @params {string} corp_type_key 1: 工业账户 2: 服务商账户
 * @return list: [{name: '企业名称', org_type_2_text: '企业类型'}]
 */
export function getSelectOption(params) {
  return request({
    url: '/account/company_list',
    method: 'get',
    params: params
  })
}

/**
 * 工业/服务商新增的时候 查询当前下拉选择的公司是否可以使用
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=505
 * @param company_name 公司名
 */
export function checkCompany(params) {
  return request({
    url: '/account/check_company',
    method: 'get',
    params: params
  })
}

/**
 * 工业/服务商企业域是否存在
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=552
 * @param company_domain 企业域名称
 */
export function checkCompanyDomain(params) {
  return request({
    url: '/account/check_domain',
    method: 'post',
    data: params
  })
}

/**
 * 创建新的工业或者服务商账号
 * 地址： http://doc.pharmconverge.com/index.php?s=/22&page_id=372
 */
export function addIndustry(params) {
  return request({
    url: params.type === 'i' ? '/account/industrycreate' : '/account/servicecreate',
    method: 'post',
    data: params.data
  })
}

/**
 * 获取单条账户编辑页面的数据
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=509
 * @param company_id 公司id
 * @param corp_type_key  1: 工业用户 2: 服务商
 */
export function getEditData(params) {
  return request({
    url: '/account/account_detail',
    method: 'get',
    params: params
  })
}

/**
 * 单条账户编辑的提交接口 (工业服务都使用)
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=511
 */
export function submitEditData(params) {
  return request({
    url: '/account/account_edit',
    method: 'post',
    data: params
  })
}

/**
 * 子账号列表
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=512
 * @param company_id 公司id
 * @param corp_type_key 1: 工业 2 服务
 * @param current_page 当前页
 * @param rp 每页条数 默认50
 */
export function getSubAccountList(params) {
  return request({
    url: '/account/sub_account_list',
    method: 'get',
    params: params
  })
}
/**
 * 子账号详情查看
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=514
 * @param company_id
 * @param corp_type_key 1 工业 2 服务
 */
export function getSubAccountDetail(params) {
  return request({
    url: '/account/sub_account_detail',
    method: 'post',
    data: params
  })
}

/**
 * 子账号编辑
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=513
 * @param company_id
 * @param corp_type_key
 * @param un_lock 1：代表解锁用户
 */
export function resetSubAccount(params) {
  return request({
    url: '/account/sub_account_edit',
    method: 'post',
    data: params
  })
}

// -------------------------------审核进度跟踪
/**
 *审核进度跟踪列表
 * 地址: http://doc.pharmconverge.com/index.php?s=/22&page_id=519
 * @param cust_no 企业编码
 * @param cust_name 企业名称
 * @param current_page 当前页
 * @param rp 每页条数
 */
export function AccountComfirmTrack(params) {
  return request({
    url: '/account/account_confirm_track',
    method: 'get',
    params: params
  })
}

/**
 * 导出
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=520
 * @param ids 可不传
 */
export function AccountComfirmExport() {
  return request({
    url: '/account/account_comfirm_expert',
    method: 'get'
  })
}

// ------------------------------------用户手续费整理
/**
 * 用户手续费管理列表
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=521
 */
export function getAccountFreeList(params) {
  return request({
    url: '/account/account_fee',
    method: 'get',
    params: params
  })
}
/**
 * 用户手续管理 手续费用明细
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=522
 * @param cust_no 企业编码
 */
export function getAccountFreeDetail(params) {
  return request({
    url: '/account/cust_service_fee',
    method: 'get',
    params: params
  })
}

/**
 * 用户手续费管理 不同时间的明细
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=545
 * @param cust_no 企业编码
 * @param service_id 服务大类
 * @param sub_service_id 服务小类
 */
export function getAccountTimeDetail(params) {
  return request({
    url: '/account/cust_service_fee_all',
    method: 'post',
    data: params
  })
}

/**
 * 服务费新增和编辑
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=524
 */
export function updateAccountFee(params) {
  return request({
    url: '/account/cust_service_fee_update',
    method: 'post',
    data: params
  })
}

/**
 * 获取创建账户时的默认值
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=591
 * 说明：返回的是一个对象 传-1返回所有的
 */
export function memberAccountDefault(params) {
  return request({
    url: '/member/account_create_default',
    method: 'get',
    params: params
  })
}
